import { useState, useEffect } from 'react';

const useEachComponentCountData = () => {
    const [loading, setLoading] = useState(true);
    const [reactAngularComponentCountData, setReactAngularComponentCountData] = useState([]);
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [reactAngularResponse] = await Promise.all([
                    fetch('https://prod.appstudioltts.com/api/linkstateupdate/count-category')
                ]);

                const componentCountData = await reactAngularResponse.json();
                
                
                setReactAngularComponentCountData(componentCountData)
                // setAngularComponentCountData(angularData);
            } catch (error) {
                console.error('Error fetching each component count data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { loading, reactAngularComponentCountData };
};

export default useEachComponentCountData;
